<div class="dialog">
  <div class="profile-icon">
    <img *ngIf="(state.guest | avatar : form.value.name | async) || '' as avatarSrc" [src]="avatarSrc" alt="" />
    <div class="label small label-primary" *ngIf="gallery">
      <ng-container *ngIf="accessLevel === 'edit'">Editor</ng-container>
      <ng-container *ngIf="accessLevel === 'review'">Reviewer</ng-container>
      <ng-container *ngIf="accessLevel === 'view_only'">View-only</ng-container>
    </div>
  </div>

  <ng-container *ngIf="!isAnonymous">
    <h1 class="no-desc">Your Visitor Profile</h1>
  </ng-container>

  <ng-container *ngIf="isAnonymous">
    <h1>{{ anonymousGuestName }}</h1>
    <p class="description">
      You’re currently anonymous. Add your info to let <b>{{ tenantName }}</b> know who you are.
    </p>
  </ng-container>

  <form [formGroup]="form" #ngForm="ngForm" [class.submitted]="ngForm.submitted" (ngSubmit)="save()">
    <app-input-field [control]="form.controls.name" [big]="true">
      <!-- <app-svg *appInputPre src="/assets/icons/user.svg"></app-svg> -->
      <input
        type="text"
        formControlName="name"
        data-test-id="guest-name"
        autocomplete="off"
        data-1p-ignore="true"
        data-lpignore="true"
        appAutofocus
      />
      <label>Name</label>
    </app-input-field>
    <app-input-field [control]="form.controls.email" [big]="true">
      <!-- <app-svg *appInputPre src="/assets/icons/email.svg"></app-svg> -->
      <input type="email" formControlName="email" data-test-id="guest-email" />
      <label>Email (Optional)</label>
    </app-input-field>

    <!-- <label for="notifications-toggle" class="switch-parent" *ngIf="state.guest?.email">
      <div class="switch" appTransitionPreventor>
        <input type="checkbox" id="notifications-toggle" formControlName="notifications" />
        <label for="notifications-toggle"></label>
      </div>
      <span>Get email updates for assets you have reviewed or interacted with.</span>
    </label> -->

    <button
      appButton
      name="confirm"
      class="confirm-button"
      location="guest-profile-dialog"
      color="primary"
      height="3"
      weight="bold"
      spacing="full"
      data-test-id="guest-cta"
      shape="round"
    >
      <span [class.hidden-text]="saving" *ngIf="isAnonymous">Add Information</span>
      <span [class.hidden-text]="saving" *ngIf="!isAnonymous">Update Info</span>
      <app-loading-indicator *ngIf="saving" color="white" size="small" class="button-loading-indicator">
      </app-loading-indicator>
    </button>
  </form>
  <button
    appButton
    name="stay-incognito"
    location="guest-profile-dialog"
    class="stay-incognito-button"
    color="simple"
    data-test-id="guest-stay-incognito"
    shape="round"
    spacing="full"
    (click)="close()"
    *ngIf="isAnonymous"
  >
    <app-svg src="/assets/icons/incognito.svg"></app-svg>
    <span>Stay Anonymous</span>
  </button>
</div>
